<template>
  <div class="px-5" style="max-height: 100vh; overflow: auto">
    <h6 class="my-10">{{ $t('PRIVACY.DISPLAY.TITLE') }}</h6>
    <span
      v-if="projectBrandObject[13].value == 2"
      v-html="projectBrandObject[13].decodedOptions.message"
    >
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProjectPrivacy",
  
  computed: {
    ...mapGetters([
      "projectBrandObject"
    ])
  }
}
</script>